<template>
    <div class="animated fadeIn" v-if="ready">
        <b-row>
            <b-col cols="6" xl="6">
                <b-form @submit.stop.prevent="save">
                    <b-card>
                        <InputField name="name" :label="this.$t('name')" v-model="user.name" @error="fieldError"
                            :rules="{ required: true, length: { min: 2 } }" />

                        <InputField type="email" name="email" :label="this.$t('email')" v-model="user.email"
                            @error="fieldError" :rules="{ required: true, length: { min: 5 } }" :disabled="true" />

                        <InputField type="password" name="password" :label="this.$t('password')" v-model="password"
                            @error="fieldError" :rules="{ required: false, length: { min: 5 } }" />

                        <InputField type="password" name="confirm_password" :label="this.$t('confirmPassword')"
                            v-model="confirm_password" @error="fieldError"
                            :rules="{ required: false, length: { min: 5 }, matchWith: password }" />

                        <b-form-group :label-cols="1" :horizontal="true">
                            <button class="btn btn-success pull-right" type="submit">{{ $t('save') }}</button>
                        </b-form-group>
                    </b-card>
                </b-form>

                <BillingInfo v-if="$isAdmin()" />
            </b-col>
            <b-col cols="6" xl="6">
                <b-card header="Referral link">
                    <code style="overflow-y: auto; width: 100%">
                    {{ publicURL }}/register?ref={{ user.ref }}
                    </code>
                </b-card>

                <b-card header="Settings">
                    <b-form-group>
                        <b-form-checkbox id="two_auth" name="two_auth" v-model="settings.two_auth">
                            {{ $t('twoFactorAuth') }}

                        </b-form-checkbox>
                    </b-form-group>

                    <b-form-group id="locale" name="locale" :label="this.$t('platformLocale')"
                        v-model="settings.locale">
                        <b-select :options="locales" v-model="locale"></b-select>
                    </b-form-group>

                    <SelectField name="timezone" :label="this.$t('timezone')" :rules="{}" :items="timezones"
                        v-model="settings.timezone" :description="this.$t('allDatesTimeZone')" />
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import IdentityFields from '@/components/identityFields/IdentityFields'
import Input from "@/components/form/Input"
import Select from '@/components/form/Select'
import timezones from 'compact-timezone-list';
import BillingInfo from './BillingInfo';
import { Switch as cSwitch } from '@coreui/vue'

export default {
    name: "Profile",
    components: {
        InputField: Input,
        SelectField: Select,
        IdentityFields,
        cSwitch,
        BillingInfo
    },
    data: function () {
        return {
            errors: [],
            personBillingErrors: [],
            billingErrors: [],
            password: "",
            confirm_password: "",
            publicURL: this.$env.get('FRONT_URL'),
            locales: [
                {
                    text: "English (US)",
                    value: "en_US"
                },
                {
                    text: "Serbian",
                    value: "sr"
                }
            ]
        }
    },
    methods: {
        fieldError(error, errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            let found = errors.find((i, e) => {
                return i.field == error.field
            })

            if (found === undefined) {
                errors.push(error)
            } else {
                errors.map(e => {
                    if (found.field == e.field)
                        e.error = error.error
                })
            }
        },

        checkForErrors(errorBag) {
            let bag = errorBag || "errors"
            let errors = this[bag]

            return errors.find((i, e) => {
                return i.error
            })
        },

        save(e) {
            e.preventDefault()

            if (this.checkForErrors()) {
                this.$bvModal.msgBoxOk(this.$t('fieldsNotValid'))

                return
            }

            if (this.password !== this.confirm_password) {
                this.$bvModal.msgBoxOk(this.$t('passwordNotValid'))

                return
            }

            let model = {
                name: this.user.name,
                email: this.user.email,
                settings: this.settings,
                billing_address: this.billingAddress
            }

            if (this.password != "") {
                model["password"] = this.password
            }

            this.$http.post("/v1/user/profile/edit", model).then(resp => {

                this.$bvToast.toast("Profile updated", {
                    variant: 'success',
                    title: "Success"
                })

                this.password = ""
            }).catch(error => {
                if (error.response.status == 500) {
                    this.$serverErrorModal(error)
                    return
                }

                this.$bvModal.msgBoxOk(error.response.data.message)
            })
        },


    },
    computed: {
        user() {
            return this.$store.getters.getUser
        },
        ready() {
            return (this.user !== null)
        },
        settings() {
            return this.user.settings
        },
        billingAddress() {
            return this.settings.billing_address || {}
        },
        timezones() {
            return timezones.map(t => {
                return {
                    text: t.label,
                    value: t.tzCode
                }
            })
        },

        locale: {
            get() {
                return this.$store.getters.getLocale
            },

            set(locale) {
                let popup = this.$loadingPopup()
                this.$store.dispatch("updateUserConfig", { path: 'locale', data: { locale: locale } }).then(() => {
                    let currentLocale = this.$store.getters.getLocale
                    if (currentLocale == locale) {
                        return
                    }

                    this.$store.commit('SET_LOCALE', locale)
                    this.$root.$i18n.locale = locale
                    this.$store.commit('RELOAD_CONTAINER')
                }).catch(err => {
                    this.$debugLog(err)

                    this.$bvToast.toast(this.$t('failedToChangeLanguageLocale'), {
                        title: this.$t('unexpectedError'),
                        variant: 'danger'
                    })
                }).finally(() => {
                    popup.hide()
                })
            }
        }
    }
}
</script>
